export default __webpack_public_path__ + "static/media/logo1500.7cc45e21.jpg";